import { inject, Injectable } from '@angular/core';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

import { Logger, LoggerPayload } from '@app/core/logging/logger';
import { AppInsightsService } from '@app/core/logging/app-insights.service';

@Injectable()
export class AppInsightsLogger implements Logger {

    private appInsightsService = inject(AppInsightsService);

    public log(title: string, payload?: LoggerPayload): void {
        this.appInsightsService.trackTrace(title, this.toProperties(payload));
    }

    public debug(title: string, payload?: LoggerPayload): void {
        this.appInsightsService.trackTrace(title, this.toProperties(payload));
    }

    public info(title: string, payload?: LoggerPayload): void {
        this.appInsightsService.trackTrace(title, this.toProperties(payload));
    }

    public warn(title: string, payload?: LoggerPayload): void {
        this.appInsightsService.trackTrace(title, this.toProperties(payload));
    }

    public error(error: unknown, payload?: LoggerPayload): void {
        this.appInsightsService.trackException(this.toError(error), null, this.toProperties(payload), null, SeverityLevel.Error);
    }

    public critical(error: unknown, payload?: LoggerPayload): void {
        this.appInsightsService.trackException(this.toError(error), null, this.toProperties(payload), null, SeverityLevel.Critical);
    }

    private toError(error: unknown): Error {
        if (error instanceof Error) {
            return error;
        }
        if (typeof error === 'string') {
            return new Error(error);
        }
        try {
            return new Error(JSON.stringify(error));
        } catch {
            return new Error('Unknown error');
        }
    }

    private toProperties(payload?: LoggerPayload): { [key: string]: unknown } | undefined {
        if (typeof payload === 'string') {
            return { payload };
        }
        return payload;
    }
}
